/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["courseCard", "addToListToggle", "addToListPopover"];

  togglePopover() {
    this.addToListPopoverTarget.classList.toggle("hidden");
  }

  mouseLeave() {
    this.addToListPopoverTarget.classList.add("hidden");
  }
}
